import React from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";

const TableBottomBar = ({ t, disabled, onContinueClick }) => (
  <div className="dt-toolbar" style={{ padding: `1em` }}>
    <div className="col-xs-12 col-md-4 col-sm-5 pull-right" style={{ textAlign: `right` }}>
      <button
        type="button"
        className="btn btn-primary"
        onClick={onContinueClick}
        disabled={disabled}
      >
        {t(`modules.localization.register.generals.button.continue`)}
      </button>
    </div>
  </div>
);

TableBottomBar.propTypes = {
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  onContinueClick: PropTypes.func.isRequired
};

export default withNamespaces()(TableBottomBar);
